import { useQueryClient } from '@tanstack/react-query';
import { IGlobalAlert } from 'src/@types/global-alert';

export const useUpdateAlerts = () => {
  const queryClient = useQueryClient();
  const queryKey = ['global-alerts'];

  const updateAlerts = (alert: IGlobalAlert) => {
    queryClient.setQueryData<IGlobalAlert[]>(
      queryKey,
      (alerts) =>
        alerts
          ? [...alerts.map((item) => (item._id === alert._id ? alert : item))]
          : [alert],
      {
        updatedAt: Date.now(),
      },
    );
  };

  return { updateAlerts };
};
